import * as types from './mutation-types'
import { getUserInfo } from '@/api/user-center.js'
import { RES_OK } from '@/api/config'
export const getUser = function ({ commit }) {
  getUserInfo().then((res) => {
    let data = res.data
    if (data && data.code === RES_OK && data.data) {
      commit(types.SET_USER, data.data)
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/actions.js